export { CarbonScore } from './CarbonScore'
export type { CarbonScoreProps } from './types'
